import HandleResponses from '@common/utils/handleResponses';
import tmsMdmAxiosInstance from '@/tms-mdm-axios';

const actions = {

  async list({ commit }, { params }) {
    try {
      if (params.page === 1) {
        commit('DEPOTS_LOADING', true);
      } else {
        commit('DEPOT_PAGINATING', true);
      }
      const result = await tmsMdmAxiosInstance('/depot', { params });
      if (result && result.data) {
        commit('ALL_DEPOT', result.data);
      }
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('DEPOTS_LOADING', false);
      commit('DEPOT_PAGINATING', false);
    }
  },

  async listSourceDepot({ commit }, { params }) {
    try {
      if (params.page === 1) {
        commit('DEPOTS_LOADING', true);
      } else {
        commit('DEPOT_PAGINATING', true);
      }
      const result = await tmsMdmAxiosInstance('/depot/userAssociated', { params });
      if (result && result.data) {
        commit('ALL_DEPOT', result.data);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('DEPOTS_LOADING', false);
      commit('DEPOT_PAGINATING', false);
    }
  },

  async show({ commit }, { depotId }) {
    try {
      commit('DEPOTS_LOADING', true);
      const result = await tmsMdmAxiosInstance(`/depot/${depotId}`);
      if (result && result.data) {
        commit('CURRENT_DEPOT', result.data);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('DEPOTS_LOADING', false);
    }
  },

  async gates({ commit }, { depotId }) {
    try {
      commit('GATES_LOADING', true);
      const result = await tmsMdmAxiosInstance(`/depot/${depotId}/gate`);
      if (result && result.data) {
        commit('DEPOT_GATE', result.data);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('GATES_LOADING', false);
    }
  },

  async docks({ commit }, { depotId }) {
    try {
      commit('DOCKS_LOADING', true);
      const result = await tmsMdmAxiosInstance(`/depot/${depotId}/dock`);
      if (result && result.data) {
        commit('DEPOT_DOCKS', result.data);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('DOCKS_LOADING', false);
    }
  },

  async update({ commit }, { depotId, data }) {
    try {
      commit('DEPOTS_LOADING', true);
      const result = await tmsMdmAxiosInstance.put(`/depot/${depotId}/`, { data });
      if (result && result.data) {
        commit('UPDATE_DEPOT_DATA', result);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('DEPOTS_LOADING', false);
    }
  },


  async create({ commit }, { data }) {
    try {
      commit('DEPOTS_LOADING', true);
      const result = await tmsMdmAxiosInstance.post('/depot/', { data });
      if (result && result.data) {
        commit('ADD_DEPOT', result);
      }
      return result;
    } catch (err) {
      return err;
    } finally {
      commit('DEPOTS_LOADING', false);
    }
  },

  async createGate({ commit }, { depotId, data }) {
    try {
      commit('GATES_LOADING', true);
      const result = await tmsMdmAxiosInstance.post(`/depot/${depotId}/gate`, { data });
      if (result && result.data) {
        commit('ADD_GATE', result);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('GATES_LOADING', false);
    }
  },

  async updateGate({ commit }, { depotId, gateId, data }) {
    try {
      commit('GATES_LOADING', true);
      const result = await tmsMdmAxiosInstance.put(`/depot/${depotId}/gate/${gateId}`, { data });
      if (result && result.data) {
        commit('UPDATE_GATE', result);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('GATES_LOADING', false);
    }
  },

  async createDock({ commit }, { depotId, data }) {
    try {
      commit('DOCKS_LOADING', true);
      const result = await tmsMdmAxiosInstance.post(`/depot/${depotId}/dock`, { data });
      if (result && result.data) {
        commit('ADD_DOCK', result);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('DOCKS_LOADING', false);
    }
  },

  async updateDock({ commit }, { depotId, dockId, data }) {
    try {
      commit('DOCKS_LOADING', true);
      const result = await tmsMdmAxiosInstance.put(`/depot/${depotId}/dock/${dockId}`, { data });
      if (result && result.data) {
        commit('UPDATE_DOCK', result);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('DOCKS_LOADING', false);
    }
  },


  async bulkUpload({ commit }, { formData, type }) {
    try {
      commit('UPLOAD_STATUS', true);
      const url = `/depot/bulk_upload?type=${type}`;
      const result = await tmsMdmAxiosInstance.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return HandleResponses.Status(result);
    } catch (error) {
      commit('UPLOAD_STATUS', false);
      return HandleResponses.Status(error);
    }
  },

  async getExcel(){
    try{
      const result = await tmsMdmAxiosInstance({ url: `/depot/excel_header`,
        method: 'GET',
        responseType: 'blob' });
      if(result){
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `VendorDepot_bulk_upload.xlsx`);
        document.body.appendChild(link);
        link.click();
      }
      return true;
    }catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async gateBulkUpload({ commit }, { formData }) {
    try {
      commit('UPLOAD_STATUS', true);
      const result = await tmsMdmAxiosInstance.post('/depot/gate_bulk_upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return HandleResponses.Status(result);
    } catch (error) {
      commit('UPLOAD_STATUS', false);
      return HandleResponses.Status(error);
    }
  },

  async uploadStatus({ commit }, { uploadType }) {
    try {
      let url = '/depot/upload_status';
      if (uploadType) {
        url = `${url}?type=${uploadType}`;
      }

      const result = await tmsMdmAxiosInstance(url);
      if (result.data && result.data.code === 'COMPLETED') {
        commit('UPLOAD_STATUS', false);
      }
      return result.data;
    } catch (error) {
      commit('UPLOAD_STATUS', false);
      return HandleResponses.Status(error);
    }
  },


  async rejectedDepots({ commit }, { transactionIds, type }) {
    commit('DOWNLOAD_STATUS', true);
    try {
      const result = await tmsMdmAxiosInstance({ url: `depot/rejected/download?transaction_ids=${transactionIds.join(',')}&type=${type}`,
        method: 'GET',
        responseType: 'blob' });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `depots-rejectedList-${now}.xlsx`);
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (err) {
      return err;
    } finally {
      commit('DOWNLOAD_STATUS', false);
    }
  },

  async rejectedGates({ commit }, { transactionIds }) {
    commit('DOWNLOAD_STATUS', true);
    try {
      const result = await tmsMdmAxiosInstance({ url: `gates/rejected/download?transaction_ids=${transactionIds.join(',')}`,
        method: 'GET',
        responseType: 'blob' });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `gates-rejectedList-${now}.xlsx`);
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (err) {
      return err;
    } finally {
      commit('DOWNLOAD_STATUS', false);
    }
  },

  async listAllDepots() {
    try {
      const result = await tmsMdmAxiosInstance.get('/depot/all');
      if (result.data) {
        return result.data;
      } else {
        return result;
      }
    } catch(error) {
      return HandleResponses.Status(error);
    }
  }

};

export default actions;
